import { render, staticRenderFns } from "./ImsQuillEditor.vue?vue&type=template&id=f59f9bce"
import script from "./ImsQuillEditor.vue?vue&type=script&lang=js"
export * from "./ImsQuillEditor.vue?vue&type=script&lang=js"
import style0 from "./ImsQuillEditor.vue?vue&type=style&index=0&id=f59f9bce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports